import ninegrid from "../index.js";
import { ngElement } from './_ngElements.js';

import {trace} from "@nopeer";

class ngVScrollBar extends ngElement
{
	#owner;
	#dragging;
	#elements;
	#interval1;
	#interval2;
	#firstThumbMove;

	#prevY = 0;

	constructor() {
		super();

		this.applyBaseStyle();
	};
	
	connectedCallback() {
		
		this.#owner = this.getRootNode().host;//this.closest("nine-grid");
		
		if (!this.#owner) return;
		
		this.shadowRoot.innerHTML = `
			<button class='ng-scroll-top' disabled><div class='ng-scroll-icon'></div></button>
			<div class='ng-scroll-track'> <div class='ng-scroll-thumb'></div> </div>
			<button class='ng-scroll-bottom'><div class='ng-scroll-icon'></div></button>
		`;

		super.connectedCallback();
		
		this.#elements = {
			//target	: this.querySelector(".ng-container-body table"),
			track	: this.shadowRoot.querySelector(".ng-scroll-track"),
			thumb	: this.shadowRoot.querySelector(".ng-scroll-thumb"),
			top		: this.shadowRoot.querySelector(".ng-scroll-top"),
			bottom	: this.shadowRoot.querySelector(".ng-scroll-bottom"),
		}
		
		this.#dragging;
		this.shiftX;
		//this.elements = {};			//track, thumb, target(resizeTarget),
		
		this.#init();
	};

	refresh = () => {
			
		if (!this.#owner) return;	//row detail 팝청창 오픈시 오류
		
		var body	= $(".ng-container-body", this.#owner.body);
		//var table	= $("table", body);
		//var track	= $(".ng-scroll-track", this);
		var thumb	= $(".ng-scroll-thumb", this.shadowRoot);
		var thead	= $("table > thead", body);
		
		var currRow		= this.#owner.dataManager.viewRecords.rawIndex;
		var trackHeight = $(this.#elements.track).height();
		var thumbHeight = $(this.#elements.thumb).height();

		// visible
		/**
		 * tr.nodata 길이가 0이 아니라 1인 경우 발생
		 */
		/**
		console.log(
			"refresh",
			this.#owner.getAttribute("display-row-count"),
		);  */

		const rowCount = Number(this.#owner.getAttribute("display-row-count") || 0);
		//console.log(rowCount);

		((rowCount >= this.#owner.dataManager.rawRecords.length) || (parseInt($('.ng-container .ng-table tr.nodata', this.#owner.body).height()) > 0 && (this.#owner.dataManager.rawRecords.length == 0 || this.#owner.dataManager.viewRecords.rawIndex == 0) ) ) ? $(this).hide() : $(this).show();
	
		
		

	
		// height
		var h = Math.min(trackHeight * (body.height() - thead.height()) / (this.#owner.template.height() * this.#owner.template.length * this.#owner.data.count()), trackHeight);
		thumb[0].dataset.height = h;
		if (h < 16) h = 16;
		
		var totalHeight = trackHeight - this.#getThumbHeight();
		if (totalHeight == 0) return;

		if (h >= trackHeight) {
			//h = v_track.height() - 10;
			thumb.css({"top": 0, "height": h - 20});
		}
		else {
			thumb.css({"height": h});
		}
		
		// top
		var y;
		if (this.#owner.isFirstPage) {
			y = 0;
		}
		else if (this.#owner.isLastPage) {
			y = trackHeight - thumbHeight - 2;
		}
		else {
			var trCnt = parseInt($('.ng-container-body tbody.bindable tr', this.#owner.body).not(".nodata").length / this.#owner.template.length);
			y = parseInt(currRow * totalHeight / (this.#owner.data.count() - trCnt + 1));

			if (y > trackHeight - thumbHeight - 3) y = trackHeight - thumbHeight - 3;
		}
		
		this.#elements.thumb.style.top = y + 'px';

		//trace.log(":::", y)
		// enable
		this.#elements.top.disabled = this.#owner.isFirstPage ? true : false;
		this.#elements.bottom.disabled = this.#owner.isLastPage ? true : false;
		
		// edge show
		($(this).is(':visible') && $("ng-hscrollbar", this.#owner.body).is(':visible')) ? $(".ng-scroll-edge", this.#owner.body).show() : $(".ng-scroll-edge", this.#owner.body).hide();
	};
	
	refreshV2 = () => {
		
		if (!this.#owner) return;	//row detail 팝청창 오픈시 오류

		var thumb	= $(".ng-scroll-thumb", this.shadowRoot);
		var currRow		= this.#owner.dataManager.viewRecords.rawIndex;
		var trackHeight = this.trackHeight;//$(this.#elements.track).height();
		var thumbHeight = this.thumbHeight;//$(this.#elements.thumb).height();

		// height
		var h = Math.min(trackHeight * (this.bodyHeight - this.theadHeight) / (this.templateHeight * this.#owner.template.length * this.#owner.data.count()), trackHeight);
		thumb[0].dataset.height = h;
		if (h < 16) h = 16;

		var totalHeight = trackHeight - this.#getThumbHeight();

		// top
		var y;
		if (this.#owner.isFirstPage) {
			y = 0;
		}
		else if (this.#owner.isLastPage) {
			y = trackHeight - thumbHeight - 2;
		}
		else {
			var trCnt = parseInt($('.ng-container-body tbody.bindable tr', this.#owner.body).not(".nodata").length / this.#owner.template.length);
			y = parseInt(currRow * totalHeight / (this.#owner.data.count() - trCnt + 1));

			if (y > trackHeight - thumbHeight - 3) y = trackHeight - thumbHeight - 3;
		}


		this.#elements.thumb.style.top = y + 'px';
		
		// enable
		this.#elements.top.disabled = this.#owner.isFirstPage ? true : false;
		this.#elements.bottom.disabled = this.#owner.isLastPage ? true : false;
	};

	delayScroll = (pos, delay1, delay2, callback) => {

		clearInterval(this.#interval1);
		clearInterval(this.#interval2);
		
		this.#owner.scrollBy(pos);
		
		this.#interval1 = setInterval(() => {
			clearInterval(this.#interval1);
			
			this.#interval2 = setInterval(() => {
				if (!this.#owner.scrollBy(pos)) {
					clearInterval(this.#interval2);
				}
				else {
					if (callback) callback.call();
				}
			}, delay2);
		}, delay1);
	};
	
	stopScroll = () => {
		clearInterval(this.#interval1);
		clearInterval(this.#interval2);
	};
	
	#init = () => {
		
		var delayScroll = (pos) => {
			
			clearInterval(this.#interval1);
			clearInterval(this.#interval2);
			
			this.#owner.scrollBy(pos);
			
			this.#interval1 = setInterval(() => {
				clearInterval(this.#interval1);
				
				this.#interval2 = setInterval(() => {
					this.#owner.scrollBy(pos);
				}, 10);
			}, 500);
		};

		$(this.#elements.top)		.on("mousedown", e => { if (e.buttons != 1 || e.altKey || e.ctrlKey || e.shiftKey) return; delayScroll(-1); });
		$(this.#elements.bottom)	.on("mousedown", e => { if (e.buttons != 1 || e.altKey || e.ctrlKey || e.shiftKey) return; delayScroll(1); });
		
		$(this.#elements.top)		.on("touchstart", e => { delayScroll(-1); });
		$(this.#elements.bottom)	.on("touchstart", e => { delayScroll(1); });

		this.#elements.top.ontouchend =
		this.#elements.bottom.ontouchend =
		this.#elements.track.ontouchend =
		this.#elements.top.onmouseup =
		this.#elements.top.onmouseleave =
		this.#elements.bottom.onmouseup =
		this.#elements.bottom.onmouseleave =
		this.#elements.track.onmouseup =
		this.#elements.track.onmouseleave = (e) => {
			 clearInterval(this.#interval1);
			 clearInterval(this.#interval2);
		};
		
		
		$(this.#elements.track)	.on("mousedown", this.#track_onMouseDown);
		
		$(this.#elements.track)	.on("touchstart", this.#track_onTouchStart);
		
		$(this.#elements.thumb)	.on("mousedown", this.#thumb_onMouseDown);
		$(this.#elements.thumb)	.on("touchstart", this.#thumb_onTouchStart);

		/**
		this.#elements.thumb.onmousedown = (e) => {
			this.#dragging = true;
			//var targetBound = this.#elements.track.getBoundingClientRect();
			this.shiftY = e.offsetY + this.#elements.track.getBoundingClientRect().y;
			
			document.addEventListener('mousemove', this.onMouseMove);
			if (typeof this.onDragStart == "function") { this.onDragStart(); }
		};
		*/
		document.addEventListener('mouseup', e => {
			if (this.#dragging) {
				this.#dragging = false;
			}
			
			document.removeEventListener('mousemove', this.#thumb_onMouseMove);
			//thumb.onmouseup = null;
			if (typeof this.onDragStop == "function") { this.onDragStop(); }
		});
		
		document.addEventListener('touchend', e => {
			this.#dragging = false;
			document.removeEventListener('touchmove', this.#thumb_onTouchMove);
			//thumb.onmouseup = null;
			if (typeof this.onDragStop == "function") { this.onDragStop(); }
		});
	};
	
	#track_onTouchStart = e => {
		
		var rect = e.target.getBoundingClientRect();
		
		e.offsetX = e.targetTouches[0].pageX - rect.left;
		e.offsetY = e.targetTouches[0].pageY - rect.top;
		e.pageX = e.changedTouches[0].pageX;
		e.pageY = e.changedTouches[0].pageY;
		e.clientX = e.changedTouches[0].clientX;
		e.clientY = e.changedTouches[0].clientY;
		
		e.buttons = 1;
		
		this.#track_onMouseDown(e);
	}
	
	#track_onMouseDown = e => {
		
		if (this.#dragging) return;
		if (e.buttons != 1 || e.altKey || e.ctrlKey || e.shiftKey) return;
		e.preventDefault();


		
		var thumbBound = this.#elements.thumb.getBoundingClientRect();
		
		clearInterval(this.#interval1);
		clearInterval(this.#interval2);
		
		(e.clientY > thumbBound.y) ? this.#owner.pageDown() : this.#owner.pageUp();
		
		this.#interval1 = setInterval(() => {
			clearInterval(this.#interval1);
			
			this.#interval2 = setInterval(() => {
				var thumbBound = this.#elements.thumb.getBoundingClientRect();
				
				if (e.clientY > thumbBound.y && e.clientY < thumbBound.y + thumbBound.height) {
					clearInterval(this.#interval2);
				}
				else {
					var isContinue = (e.clientY > thumbBound.y) ? this.#owner.pageDown() : this.#owner.pageUp();
					if (!isContinue) {
						clearInterval(this.#interval2);
					}
					else {
					}
				}
			}, 10);
		}, 500);
	};
	
	#thumb_onTouchStart = e => {
		var rect = e.target.getBoundingClientRect();
		
		e.offsetX = e.targetTouches[0].pageX - rect.left;
		e.offsetY = e.targetTouches[0].pageY - rect.top;
		e.pageX = e.changedTouches[0].pageX;
		e.pageY = e.changedTouches[0].pageY;
		e.clientX = e.changedTouches[0].clientX;
		e.clientY = e.changedTouches[0].clientY;
		
		e.buttons = 1;
		
		this.#thumb_onMouseDown(e);
		
		document.addEventListener('touchmove', this.#thumb_onTouchMove);
	};
	
	#thumb_onTouchMove = e => {
		var rect = e.target.getBoundingClientRect();
		
		e.offsetX = e.targetTouches[0].pageX - rect.left;
		e.offsetY = e.targetTouches[0].pageY - rect.top;
		e.pageX = e.changedTouches[0].pageX;
		e.pageY = e.changedTouches[0].pageY;
		e.clientX = e.changedTouches[0].clientX;
		e.clientY = e.changedTouches[0].clientY;
		
		e.buttons = 1;
		
		this.#thumb_onMouseMove(e);
	};
	
	#thumb_onMouseDown = e => {
		this.#prevY = e.clientY; // 초기 Y 좌표 저장
		//trace.log("::", e, e.clientY);

		this.#dragging = true;
		//var targetBound = this.#elements.track.getBoundingClientRect();
		this.shiftY = e.offsetY + this.#elements.track.getBoundingClientRect().y;
		
		this.trackHeight	= $(this.#elements.track).height();
		this.thumbHeight	= $(this.#elements.thumb).height();
		this.nodataHeight	= $('.ng-container .ng-table tr.nodata', this.#owner.body).height();
		this.bodyHeight		= $(".ng-container-body", this.#owner.body).height();
		this.templateHeight	= this.#owner.template.height();
		this.theadHeight	= $(".ng-container-body table > thead", this.#owner.body).height() || 0;
		this.tfootHeight	= $(".ng-container-body table > tfoot", this.#owner.body).height() || 0;
		this.fixedHeight	= $(".ng-container-body tbody.fixed", this.#owner.body).height();
		this.tableHeight	= $(".ng-container-body .ng-table", this.#owner.body).height();
		
		this.#firstThumbMove = true;
		document.addEventListener('mousemove', this.#thumb_onMouseMove);
		if (typeof this.onDragStart == "function") { this.onDragStart(); }
	};


	#thumb_onMouseMove = (e) => {
		if (!this.#dragging) return;

		e.preventDefault();

		var deltaY = e.clientY - this.#prevY;
		//this.#prevY = e.clientY; // 다음을 위해 현재값 저장

		if (this.#firstThumbMove) {
			ninegrid.j.querySelectorAll("th,td", this.#owner.body).removeClass("active").removeClass("multi-selected").removeClass("selected").removeClass("selected-current").removeClass("selected-area").removeClass("selected-top").removeClass("selected-bottom").removeClass("selected-left").removeClass("selected-right");
			this.#firstThumbMove = false;
		}

		var trackHeight = this.trackHeight;//$(this.#elements.track).height();
		let thumbHeight = this.#getThumbHeight();

		var y = e.clientY - this.shiftY;
		if (y < 0) y = 0;
		if (y + this.thumbHeight > trackHeight) y = parseInt(trackHeight - thumbHeight);

		//this.#elements.thumb.style.top = y + 'px';
		
		var trCnt = parseInt($(".ng-container-body tbody.bindable tr", this.#owner.body).not(".nodata").length / this.#owner.template.length);
		var toRow = parseInt(y * (this.#owner.data.count() + 1 - trCnt) / parseInt(trackHeight - thumbHeight));

		// 1. 필요한 변수 준비 (이미 클래스 내부에 정의되어 있거나 계산 가능)




		//trace.log("첫 번째 행 높이:", rowHeight0, "필요한 트랙 이동 거리(yDelta):", yDelta);


		//var deltaContent = deltaY;


		if (this.#owner.dataManager.viewRecords.rawIndex != toRow) {
			this.#owner.scrollToV2(toRow);

			this.#prevY = e.clientY;
			//this.#owner.setScrollTransform(0);
			this.#scrollTransform(0);
		} else {

			this.#elements.thumb.style.top = y + 'px';
			if (y <= 0) {
				this.#scrollTransform(0);
				return;
			}

			let rowHeight0 = this.#owner.matrix.getHeight(toRow);
			let scrollableTrack = Math.max(0, trackHeight - thumbHeight); // 썸이 움직일 수 있는 전체 트랙 거리
			let scrollableContent = Math.max(0, this.#owner.matrix.getTotalHeight() - this.bodyHeight); // 콘텐츠 전체 스크롤 범위

			let yDelta = (scrollableContent > 0) ? (rowHeight0 * (scrollableTrack / scrollableContent)) : 0;

			//trace.log(rowHeight0, yDelta, deltaY, toRow, (rowHeight0 * deltaY / yDelta));

			// 3. #bodyTop(누적값) 갱신 및 경계 처리
			let offset = (deltaY > 0) ? Math.abs(rowHeight0 * deltaY / yDelta) : Math.abs(rowHeight0 + (rowHeight0 * deltaY / yDelta));

			// 4. 즉시 적용
			this.#scrollTransform(-offset);

		}
	};

	#scrollTransform(offset) {

		if (offset > 0) offset = 0;

		const bodies = this.#owner.body.querySelectorAll("tbody.bindable");

		// 2. 루프를 돌며 각각의 스타일을 적용합니다.
		bodies.forEach(body => {
			body.style.transform = `translateY(${offset}px)`;
		});
	}
	
	#getThumbHeight = () => {
		return parseInt(this.#elements.thumb.dataset.height);
	};
}

class ngHScrollBar extends ngElement
{
	#owner;
	#dragging;
	#elements;
	#interval1;
	#interval2;
	
	constructor() {
		super();
		
		this.applyBaseStyle();
	};
	
	connectedCallback() {
		this.#owner = this.getRootNode().host;//this.closest('nine-grid');

		this.shadowRoot.innerHTML = `
			<button class='ng-scroll-left' disabled><div class='ng-scroll-icon'></div></button>
			<div class='ng-scroll-track'><div class='ng-scroll-thumb'></div></div>
			<button class='ng-scroll-right'><div class='ng-scroll-icon'></div></button>
		`;

		super.connectedCallback();
		
		this.#elements = {
			container	: this.#owner.shadowRoot.querySelector(".ng-container-body"),
			track		: this.shadowRoot.querySelector(".ng-scroll-track"),
			thumb		: this.shadowRoot.querySelector(".ng-scroll-thumb"),
			left		: this.shadowRoot.querySelector(".ng-scroll-left"),
			right		: this.shadowRoot.querySelector(".ng-scroll-right"),	
		};
		
		this.#dragging;
		this.shiftX;
		//this.elements = {};			//track, thumb, target(resizeTarget),
		
		this.#init();
		
		//super.connectedCallback();
	};

	refresh = () => {
			
		if (!this.#owner) return;	//row detail 팝청창 오픈시 오류
		
		var body	= $(".ng-container-body", this.#owner.body);
		var table	= $("table", body);
		var track	= $(".ng-scroll-track", this.shadowRoot);
		var thumb	= $(".ng-scroll-thumb", this.shadowRoot);

		// visible
		body.width() != 0 && table.width() > body.width() ? $(this.#owner.body.querySelector(".ng-container-bottom")).show() : $(this.#owner.body.querySelector(".ng-container-bottom")).hide();

		// width
		thumb.width( Math.min(track.width() * body.width() / table.width(), track.width()) );
		
		// left
		var l = parseInt(Math.abs(table.position().left) * track.width() / table.width());
		if (l < 0) l = 0;
		if (l + thumb.width() > track.width()) l = track.width() - thumb.width();
		
		thumb.css({left : l});

		// enable
		ninegrid.j.querySelectorAll(".ng-scroll-left", this.shadowRoot).attr("disabled", l == 0 ? true : false);
		ninegrid.j.querySelectorAll(".ng-scroll-right", this.shadowRoot).attr("disabled", (l == track.width() - thumb.width()) ? true : false);
		
		// edge show
		var vbar = this.#owner.body.querySelector("ng-vscrollbar");
		($(this).is(':visible') && $(vbar).is(':visible')) ? $(".ng-scroll-edge", this.#owner.body).show() : $(".ng-scroll-edge", this.#owner.body).hide();
	};
	
	scrollToHome = () => {
		this.#thumbMoveTo(0);
	}
	
	scrollToEnd = () => {
		var trackBound		= this.#elements.track.getBoundingClientRect();
		var thumbBound		= this.#elements.thumb.getBoundingClientRect();
		
		var x = trackBound.width-thumbBound.width;
		
		this.#thumbMoveTo(x);
	}
	//this.#thumbMoveTo(e.pageX - this.shiftX);
	#thumbMoveTo = (x) => {
		
		if (!this.#elements) return;	//row detail 팝청창 오픈시 오류
		//var thisBound			= this.getBoundingClientRect();
		//var targetBound		= this.#elements.target.getBoundingClientRect();
		
		var table = $("table", this.#elements.container);
		var trackBound		= this.#elements.track.getBoundingClientRect();
		var thumbBound		= this.#elements.thumb.getBoundingClientRect();

		if (x < 0) x = 0;
		if (x + thumbBound.width > trackBound.width) x = trackBound.width-thumbBound.width;
		x = parseInt(x);
		
		this.#elements.thumb.style.left = x + 'px';
		//this.#elements.target.style.left = parseInt(-x * (this.#elements.table.width() - thisBound.width) / (this.#elements.table.width() - thumbBound.width)) + 'px';
		this.#elements.left.disabled = x == 0 ? true : false;
		this.#elements.right.disabled = (x == parseInt(trackBound.width - thumbBound.width)) ? true : false;
		
		// (trackBound.width - thumbBound.width) : x = w : ?
		var w2 = $(this.#elements.container).width();
		var w = $(table).width();
		var l = (-x * (w-w2) / (trackBound.width - thumbBound.width));
		if (-l > w-w2) l = w-w2;
		if (-l+5 > w-w2) l = -(w-w2);

		if (w2 >= w) l = 0;
		$(table).css({left : l});
		
		return (x == 0 || x == trackBound.width - thumbBound.width) ? false : true;
	};
	
	adjustThumb2 = () => {

		var table		= $(".ng-container-body > table", this.#owner.body);
		var track		= $(".ng-scroll-track", this.shadowRoot);
		var thumb		= $(".ng-scroll-thumb", this.shadowRoot);

		var l = parseInt(Math.abs(table.position().left) * track.width() / table.width());
		if (l < 0) l = 0;
		if (l + thumb.width() > track.width()) l = track.width() - thumb.width();
		
		thumb.css({left : l});

		ninegrid.j.querySelectorAll(".ng-scroll-left", this.shadowRoot).attr("disabled", l == 0 ? true : false);
		ninegrid.j.querySelectorAll(".ng-scroll-right", this.shadowRoot).attr("disabled", (l == track.width() - thumb.width()) ? true : false);
	}
	
	#init = () => {

		
		
		var delayScroll = (pos) => {

			clearInterval(this.#interval1);
			clearInterval(this.#interval2);
			
			var trackBound = this.#elements.track.getBoundingClientRect();
			var thumbBound = this.#elements.thumb.getBoundingClientRect();
			
			this.#thumbMoveTo(thumbBound.x - trackBound.x + pos);
			
			this.#interval1 = setInterval(() => {
				clearInterval(this.#interval1);
				
				this.#interval2 = setInterval(() => {
					var thumbBound = this.#elements.thumb.getBoundingClientRect();
					if (!this.#thumbMoveTo(thumbBound.x - trackBound.x + pos)) clearInterval(this.#interval2);
				}, 10);
			}, 500);
		};
		
		this.#elements.left.ontouchend =
		this.#elements.right.ontouchend =
		this.#elements.track.ontouchend =
		this.#elements.left.onmouseup =
		this.#elements.left.onmouseleave =
		this.#elements.right.onmouseup =
		this.#elements.right.onmouseleave =
		this.#elements.track.onmouseup
		this.#elements.track.onmouseleave = (e) => {
			clearInterval(this.#interval1);
			clearInterval(this.#interval2);
		};
		
		
		$(this.#elements.left)	.on("mousedown", e => { if (e.buttons != 1 || e.altKey || e.ctrlKey || e.shiftKey) return; delayScroll(-10); });
		$(this.#elements.right)	.on("mousedown", e => { if (e.buttons != 1 || e.altKey || e.ctrlKey || e.shiftKey) return; delayScroll(10); });

		$(this.#elements.left)	.on("touchstart", e => { delayScroll(-10); });
		$(this.#elements.right)	.on("touchstart", e => { delayScroll(10); });

		$(this.#elements.track)	.on("mousedown", this.#track_onMouseDown);
		$(this.#elements.track)	.on("touchstart", this.#track_onTouchStart);
		
		$(this.#elements.thumb)	.on("mousedown", this.#thumb_onMouseDown);
		$(this.#elements.thumb)	.on("touchstart", this.#thumb_onTouchStart);
		
		document.addEventListener('touchend', (e) => {
					
			this.#dragging = false;
			clearInterval(this.#interval1);
			clearInterval(this.#interval2);
			
			$(document).off('touchmove', this.#thumb_onTouchMove);

			if (typeof this.onDragStop == "function") { this.onDragStop(); }
		});
		document.addEventListener('mouseup', (e) => {
			
			this.#dragging = false;
			clearInterval(this.#interval1);
			clearInterval(this.#interval2);
			
			document.removeEventListener('mousemove', this.#thumb_onMouseMove);

			if (typeof this.onDragStop == "function") { this.onDragStop(); }
		});
	};
	
	#thumbScroll = (clientX) => {
		var thumbBound = this.#elements.thumb.getBoundingClientRect();
		var tableLeft = parseInt($(".ng-container-body > table", this.#owner.body).position().left);
		var l = 0;
		if (clientX > thumbBound.x) {	// move right
			
			$(".ng-container-body .col-indicator", this.#owner.body).each((i,el) => {
				l += parseInt($(el).width()) + 2;
				if (l > Math.abs(tableLeft) + 1) return false;
			});
			

		}
		else {
			$(".ng-container-body .col-indicator", this.#owner.body).each((i,el) => {
				if (l + parseInt($(el).width()) + 2 >= Math.abs(tableLeft)) return false;
				l += parseInt($(el).width()) + 2;
			});
		}
		
		$(".ng-container-body > table", this.#owner.body).css({left : -l});

		this.refresh();
	}
	
	#track_onTouchStart = e => {
		var rect = e.target.getBoundingClientRect();
		
		e.offsetX = e.targetTouches[0].pageX - rect.left;
		e.offsetY = e.targetTouches[0].pageY - rect.top;
		e.pageX = e.changedTouches[0].pageX;
		e.pageY = e.changedTouches[0].pageY;
		e.clientX = e.changedTouches[0].clientX;
		e.clientY = e.changedTouches[0].clientY;
		
		e.buttons = 1;
		
		this.#track_onMouseDown(e);
	};
	
	#track_onMouseDown = e => {
		if (this.#dragging) return;
		if (e.buttons != 1 || e.altKey || e.ctrlKey || e.shiftKey) return;
		e.preventDefault();
	
		this.#thumbScroll(e.clientX);

		this.#interval1 = setInterval(() => {
			clearInterval(this.#interval1);
			
			this.#interval2 = setInterval(() => {
				var thumbBound = this.#elements.thumb.getBoundingClientRect();
				if (e.clientX > thumbBound.x && e.clientX<thumbBound.x + thumbBound.width) {
					clearInterval(this.#interval2);
				}
				else {
					this.#thumbScroll(e.clientX);
				}
			}, 10);
		}, 500);
	};
	
	#thumb_onTouchStart = e => {
		var rect = e.target.getBoundingClientRect();
		
		e.offsetX = e.targetTouches[0].pageX - rect.left;
		e.offsetY = e.targetTouches[0].pageY - rect.top;
		e.pageX = e.changedTouches[0].pageX;
		e.pageY = e.changedTouches[0].pageY;
		e.clientX = e.changedTouches[0].clientX;
		e.clientY = e.changedTouches[0].clientY;
		
		e.buttons = 1;
		
		this.#thumb_onMouseDown(e);
		
		document.addEventListener('touchmove', this.#thumb_onTouchMove);
	};
	
	
		
	#thumb_onMouseDown = e => {
		this.#dragging = true;


		var w = Math.min($(this.#elements.track).width() * $(this.#owner.body.querySelector(".ng-container-body")).width() / $(this.#owner.body.querySelector(".ng-container-body > table")).width(), $(this.#elements.track).width());

		$(this.#elements.thumb).width( parseInt(w) );
		$(this.#elements.thumb).css( {"width": parseInt(w), "min-width": parseInt(w)} );

		this.shiftX = e.offsetX+ this.#elements.track.getBoundingClientRect().x;
		document.addEventListener('mousemove', this.#thumb_onMouseMove);
		if (typeof this.onDragStart == "function") { this.onDragStart(); }
	};
	
	#thumb_onTouchMove = e => {
		var rect = e.target.getBoundingClientRect();
		
		e.offsetX = e.targetTouches[0].pageX - rect.left;
		e.offsetY = e.targetTouches[0].pageY - rect.top;
		e.pageX = e.changedTouches[0].pageX;
		e.pageY = e.changedTouches[0].pageY;
		e.clientX = e.changedTouches[0].clientX;
		e.clientY = e.changedTouches[0].clientY;
		
		e.buttons = 1;
		
		this.#thumb_onMouseMove(e);
	};

	#thumb_onMouseMove = e => {
			
		if (!this.#dragging) return;
		//e.preventDefault();
		
		this.#thumbMoveTo(e.pageX - this.shiftX);
	};
	
}

if (!customElements.get('ng-hscrollbar')) {
	customElements.define("ng-hscrollbar", ngHScrollBar);
}

if (!customElements.get('ng-vscrollbar')) {
	customElements.define("ng-vscrollbar", ngVScrollBar);
}